  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import handleResponseNoWU from "./handleResponseNoWU";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_GeolocationService = {
  wu_geolocation,
  wu_geolocationPro,
};
//----------------------------------------------------------------------------------------------------
function wu_geolocation(reqData) {
  const methName = "wu_geolocation ";
  const localUrl = api.url_onlinemt + api.webapp_path + "/findCountryFromIP";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "text/json",
      "Accept"                      : "text/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : (localStorage.getItem("isLoggedIn")==="true") ? localStorage.getItem("tokenID")                : "9203480324982039480329920348023482308093",
      "Authorization"               : (localStorage.getItem("isLoggedIn")==="true") ? "Bearer "+ localStorage.getItem("accessToken") : "Bearer "+localStorage.getItem("HTTP_user"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  //const data = {
  //
  //};
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_geolocationPro(reqData) {
  const methName = "wu_geolocationPro ";
  const localUrl = "https://pro.ip-api.com/json?key=6oQd1BPUtKuhIgr";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    }
  };
  //const data = {
  //
  //};
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponseNoWU)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
